/* Opus Member Events: "Invite a friend" (snippets/ev-invite.liquid).
   The gift guide's "Drop a hint", reworked for events. Tickets are one spot per person,
   so this sends the event link to a friend so they can book their own spot.
   Phones: native share sheet. Desktop: copy the message + link, with an email fallback.
   One delegated click listener, so buttons in the cart drawer still work after it re-renders.
   Safe to include more than once on a page. */
(() => {
  if (window.opusEvInvite) return;
  window.opusEvInvite = true;

  const track = (name, detail) => {
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, detail);
    } catch (e) {}
  };

  let toastTimer;
  const toast = (html) => {
    let t = document.querySelector('.ev-toast');
    if (!t) {
      const style = document.createElement('style');
      style.textContent = `
        .ev-toast { position: fixed; left: 50%; bottom: 24px; z-index: 10000; transform: translate(-50%, 20px); opacity: 0; pointer-events: none;
          display: flex; flex-wrap: wrap; gap: 6px 14px; align-items: center; max-width: calc(100vw - 32px); padding: 12px 18px; border-radius: 999px;
          background: rgba(18, 18, 18, .88); -webkit-backdrop-filter: blur(16px); backdrop-filter: blur(16px); color: #fff; font-size: 1.4rem;
          box-shadow: 0 8px 24px rgba(0, 0, 0, .25); transition: opacity .2s ease, transform .2s ease; }
        .ev-toast.is-on { opacity: 1; transform: translate(-50%, 0); pointer-events: auto; }
        .ev-toast a { color: #fff; text-decoration: underline; text-underline-offset: 3px; }
        @media (prefers-reduced-motion: reduce) { .ev-toast { transition: none; } }`;
      document.head.appendChild(style);
      t = document.createElement('div');
      t.className = 'ev-toast';
      t.setAttribute('role', 'status');
      document.body.appendChild(t);
    }
    t.innerHTML = html;
    t.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => t.classList.remove('is-on'), 5000);
  };

  const invite = async (btn) => {
    const { url, title } = btn.dataset;
    const message = btn.dataset.message || `Come with me? 🎨 ${title}. Everyone books their own spot here:`;
    const subject = btn.dataset.subject || 'Come to an Opus event with me 🎨';
    track('ev_invite_friend', { event: title });
    if (navigator.share && window.matchMedia('(pointer: coarse)').matches) {
      try { await navigator.share({ title, text: message, url }); } catch (e) {}
      return;
    }
    const mail = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(`${message}\n${url}`)}`;
    try {
      await navigator.clipboard.writeText(`${message} ${url}`);
      toast(`<span>Invite copied, paste it to a friend.</span> <a href="${mail}">Email it instead</a>`);
    } catch (e) {
      window.location.href = mail;
    }
  };

  document.addEventListener('click', (e) => {
    const btn = e.target.closest && e.target.closest('[data-ev-invite]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    invite(btn);
  });
})();
